export const Title = () => (
  <div className="mt-m pt-m text-center text-base">
    <h1 className="text-lg font-semibold text-gray-900">Manual verification</h1>
    <p className="mt-xxs text-base font-medium text-gray-500">
      Help our moderators by writing a little about yourself and why you want to
      create an account.
    </p>
  </div>
)
